import { createAction } from 'redux-actions';

export const EXPAND_STATE = 'EXPAND_STATE';
export const changeExpandState = createAction(EXPAND_STATE);

export const INITIAL_ANIMATION = 'INITIAL_ANIMATION';
export const toggleInitialAnimation = createAction(INITIAL_ANIMATION);
